import apiAuth from '@/api/auth'
import router from '@/router'
import { getToken, setTokenRemember, setToken, removeToken } from '@/utils/auth'

const state = { token: getToken() }

const actions = {
  login({ commit }, { username, password, isRemember }) {
    return new Promise((resolve, reject) => {
      apiAuth.login(username, password).then(
        data => {
          commit('loginSuccess', data.token)

          if (isRemember === true) setTokenRemember(data.token)
          else setToken(data.token)

          router.push('/user')

          resolve()
        },
        error => {
          reject(error)
        }
      )
    })
  },
  logout({ commit, dispatch }) {
    dispatch('userInfo/clearUserInfo', {}, { root: true })
    removeToken()
    commit('logout')
    router.push('/login')
  }
}

const mutations = {
  loginSuccess(state, token) {
    state.token = token
  },
  logout(state) {
    state.token = null
  }
}

export const auth = {
  namespaced: true,
  state,
  actions,
  mutations
}
